import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom, filter, take } from 'rxjs/operators';
import { toPayload } from '../../core/helpers/rx-pipes';
import * as checkout from '../actions/checkout';
import * as cart from '../../cart/actions/cart';
import * as orders from '../../orders/actions/orders';
import * as fromCart from '../../cart/reducers';
import * as fromAuth from '../../auth/reducers';
import { CheckoutService } from '../services/checkout-service';
import { DeliveryDateService } from '../services/deliverydate-service';
import { BackorderCountsService } from '../services/backordercount-service';
var CheckoutEffects = /** @class */ (function () {
    function CheckoutEffects(checkoutSvc, deliveryDateSvc, backorderCountsSvc, store, actions$, router) {
        var _this = this;
        this.checkoutSvc = checkoutSvc;
        this.deliveryDateSvc = deliveryDateSvc;
        this.backorderCountsSvc = backorderCountsSvc;
        this.store = store;
        this.actions$ = actions$;
        this.router = router;
        this.cleanCart$ = this.actions$.ofType(checkout.SUBMIT_SUCCESS)
            .pipe(map(function (action) { return new cart.Reset(); }));
        this.setDetails$ = this.actions$.ofType(checkout.SET)
            .pipe(toPayload(), switchMap(function (order) {
            return _this.checkoutSvc.setOrderDetails(order)
                .pipe(map(function (order) { return new checkout.SetSuccess(order); }), catchError(function (e) { return of(new checkout.SetFailed(e)); }));
        }));
        this.order$ = this.actions$
            .pipe(ofType(checkout.SUBMIT), toPayload(), switchMap(function (order) {
            return _this.checkoutSvc.submitOrder(order)
                .pipe(map(function (result) { return new checkout.SubmitSuccess(result); }), catchError(function (e) { return of(new checkout.SubmitFailed(e)); }));
        }));
        this.orderCreated$ = this.actions$.ofType(checkout.SUBMIT_SUCCESS)
            .pipe(toPayload(), tap(function (order) { return _this.router.navigate(['/checkout/summary/' + order._id]); }), map(function (order) { return new orders.Add(order); }));
        this.getDeliveryDates = this.actions$.pipe(ofType(checkout.GET_DELIVERY_DATES), withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), function (action, customerId) { return ({ action: action, customerId: customerId }); }), switchMap(function (data) {
            return _this.deliveryDateSvc.getDeliveryDates(data.customerId).pipe(map(function (response) { return new checkout.GetDeliveryDatesSuccess(response); }), catchError(function (e) { return of(new checkout.GetDeliveryDatesFailed(e)); }));
        }));
        this.getBackorderCounts$ = this.actions$.pipe(ofType(checkout.GET_BACKORDER_COUNTS), withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), this.store.pipe(select(fromCart.getOrderId)), function (action, customerId, orderId) { return ({ action: action, customerId: customerId, orderId: orderId }); }), filter(function (data) { return !!data.orderId; }), switchMap(function (data) {
            return _this.backorderCountsSvc.getBackorderCountsForOrder(data.orderId, data.customerId).pipe(map(function (response) { return new checkout.GetBackorderCountsSuccess(response); }), catchError(function (e) { return of(new checkout.GetBackorderCountsFailed(e)); }));
        }));
        this.getBackorderCountsOnFirstSuccesfullCartGet$ = this.actions$.pipe(ofType(cart.GET_SUCCESS), take(1), withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId)), this.store.pipe(select(fromCart.getOrderId)), function (action, customerId, orderId) { return ({ action: action, customerId: customerId, orderId: orderId }); }), filter(function (data) { return !!data.orderId; }), switchMap(function (data) {
            return _this.backorderCountsSvc.getBackorderCountsForOrder(data.orderId, data.customerId).pipe(map(function (response) { return new checkout.GetBackorderCountsSuccess(response); }), catchError(function (e) { return of(new checkout.GetBackorderCountsFailed(e)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CheckoutEffects.prototype, "cleanCart$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CheckoutEffects.prototype, "setDetails$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CheckoutEffects.prototype, "order$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CheckoutEffects.prototype, "orderCreated$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CheckoutEffects.prototype, "getDeliveryDates", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CheckoutEffects.prototype, "getBackorderCounts$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CheckoutEffects.prototype, "getBackorderCountsOnFirstSuccesfullCartGet$", void 0);
    return CheckoutEffects;
}());
export { CheckoutEffects };
